<template>
  <div
    id="provider-puzzles"
  >
    <h2>
      {{ provider.title }} Puzzles
    </h2>

    <provider-nav
      :providerId="providerId"
    />

    <pagination
      :resourceUrl="puzzlesUrl"
      orderBy="date"
      orderType="DESC"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <puzzle-list :puzzle="item" />
      </template>
    </pagination>
  </div>
</template>
<script>
import ProviderNav from '@/components/ProviderNav'
import PuzzleListItem from '@/components/PuzzleListItem'

import Pagination from 'sai-vue-kaminari'
import { mapState } from 'vuex'

export default {
  props: {
    providerId: {
      type: [ Number, String ],
      required: true
    }
  },

  components: {
    'pagination': Pagination,
    'provider-nav': ProviderNav,
    'puzzle-list': PuzzleListItem
  },

  computed: mapState({
    base: state => state.base,
    provider: state => state.ProviderModule.provider,

    puzzlesUrl () {
      return this.apiUrl(
        '/providers/' + parseInt(this.providerId) + '/puzzles',
        true
      )
    }
  }),

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        'ProviderModule/getProvider', this.providerId
      ).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProviderPuzzles.vue